import { Design } from '@guardian/types';
export const decidePillar = ({ pillar, design, }) => {
    // We override the pillar to be opinion on Comment news pieces
    if (design === Design.Comment && pillar === 'news')
        return 'opinion';
    return pillar;
};
